<template>
    <div>
      <!--添加通知信息-->
      <div class="logindiv" id="AddForm_timetask">
        <div class="loginForm">
          <div style="width: 100%;height: 40px;background-color: #2d2d2d;margin: 0 auto;">
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
              添加定时任务
            </span>
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
              <a href="javascript:;" @click="close">
                <i class="el-icon-close"></i>
              </a>
            </span>
          </div>
          <div style="width: 300px;margin: 0 auto;">
            <el-form :model="AddForm" :rules="rules" ref="AddForm" style="margin-top: 30px;">
              <el-form-item prop="task_id" label="任务类型">
                <el-select v-model="AddForm.task_id" placeholder="请选择任务类型" style="width: 100%;">
                  <el-option
                    v-for="item in options_task"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="repeat_type" label="重复方式">
                <el-select v-model="AddForm.repeat_type" placeholder="请选择重复方式" style="width: 100%;">
                  <el-option label="一次" value="0"></el-option>
                  <el-option label="每天" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="name" label="任务名称">
                <el-input type="text" v-model="AddForm.name" placeholder="任务名称"></el-input>
              </el-form-item>
              <el-form-item prop="start_time" label="开始时间">
                <el-date-picker
                  v-model="AddForm.start_time"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择开始时间" style="width: 100%;">
                </el-date-picker>
              </el-form-item>
              <el-form-item prop="describe" label="任务描述">
                <el-input type="text" v-model="AddForm.describe" placeholder="任务描述"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="loading" style="width: 300px;" v-if="AddForm.tp==0" @click="AddLabel">提交</el-button>
                <el-button type="primary" :loading="loading" style="width: 300px;" v-else-if="AddForm.tp==1" @click="UpdateLabel">保存</el-button>
              </el-form-item>
            </el-form>
          </div>
          <br>
        </div>
      </div>
      <div>
        <el-container>
          <el-header style="background-color:white;margin-top: 5px;height: 40px;">
            <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
              <el-form-item>
                <el-button type="primary" class="btn" @click="Addwindow()"><i class="el-icon-circle-plus-outline"></i>添加新任务</el-button>
              </el-form-item>
              <el-form-item label="任务名称">
                <el-input v-model="formInline.name" placeholder="任务名称"></el-input>
              </el-form-item>
              <el-form-item label="任务状态">
                <el-select v-model="formInline.type" class="elInput" style="width: 120px;">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="正常" value="1"></el-option>
                  <el-option label="停用" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="btn" @click="getData()"><i class="el-icon-search"></i>查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="danger" class="btn" @click="resetting()"><i class="el-icon-refresh"></i>重置</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="success" class="btn" @click="openTimetasks()"></i>开启定时任务</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="info" class="btn" @click="closeTimetasks()"></i>关闭定时任务</el-button>
              </el-form-item>
            </el-form>
          </el-header>
          <el-main class="elMain">
            <el-table v-loading="loading" :data="tableData" height="100%" stripe border size="medium ">
              <el-table-column align="center" label="ID" prop="id" width="100"></el-table-column>
              <el-table-column align="center" label="任务名称" prop="name" width="200"></el-table-column>
              <el-table-column align="center" label="任务类型" prop="task_name" width="200"></el-table-column>
              <el-table-column align="center" label="重复方式" prop="repeat_type" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.repeat_type=='0'">一次</span>
                  <span v-else>每天</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="首次执行时间" prop="start_time" width="200"></el-table-column>
              <el-table-column align="center" label="任务描述" prop="describe"></el-table-column>
              <el-table-column align="center" label="修改/创建时间" prop="time" width="200">
                <template slot-scope="scope">
                  <span>{{scope.row.time*1 | formatDate}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="状态" prop="type" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.type=='0'" style="color: red;">停用</span>
                  <span v-else>正常</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="250">
                <template slot-scope="scope">
                  <span>
                    <el-button size="small" @click="Updatewindow(scope.row)">修改</el-button>
                  </span>
                  <span>
                    <el-button size="small" slot="reference" @click="updateType(scope.$index, scope.row)">状态修改</el-button>
                  </span>
                  <!--
                  <span>
                    <el-popconfirm
                      confirmButtonText='好的'
                      cancelButtonText='不用了'
                      icon="el-icon-info"
                      iconColor="red"
                      title="这是一段内容确定删除吗？"
                      @onConfirm="deletes(scope.$index, scope.row)"
                    >
                      <el-button size="small" slot="reference">删除</el-button>
                    </el-popconfirm>
                  </span>
                  -->
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
            <div style="padding: 15px 0;text-align: right;">
              <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.pageNum"
                :page-sizes="pageSizes" :page-size="formInline.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
              </el-pagination>
            </div>
          </el-footer>
        </el-container>
      </div>
    </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  export default {
    data() {
      var task_id = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('请选择任务类型'))
        } else {
          callback()
        }
      }
      var repeat_type = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('请选择重复方式'))
        } else {
          callback()
        }
      }
      var start_time = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('请选择开始时间'))
        } else {
          callback()
        }
      }
      var name = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('请输入任务名称'))
        } else {
          callback()
        }
      }
      return {
        options_task:'',
        data:'',
        tableData: [],
        loading: false,
        formInline: {
          type:'',
          name:'',
          pageNum:1,
          pageSize:10
        },
        pageSizes:[5, 10, 15, 20],
        pageTotal:0,
        AddForm:{
          task_id:'',
          repeat_type:'',
          start_time:'',
          name:'',
          interval_time:'',
          describe:'',
          tp:0
        },
        rules: {
          task_id: [{
            required: true,
            trigger: 'blur',
            validator: task_id
          }],
          repeat_type: [{
            required: true,
            trigger: 'blur',
            validator: repeat_type
          }],
          start_time: [{
            required: true,
            trigger: 'blur',
            validator: start_time
          }],
          name: [{
            required: true,
            trigger: 'blur',
            validator: name
          }]
        },
      }
    },
    //页面开启时执行
    mounted(){
      this.chark();
      this.getData();
    },
    methods: {
      closeTimetasks(){
        let admin_id=this.$store.state.a_id;
        commonAPI('closeTimeTasks',this.formInline).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){}
        }).catch(error=>{
          this.loading = false;
          this.$notify({//这里采用element ui的一个错误显示效果模板
            title: '提示',
            message: error.message,
            position: 'bottom-right',
            type: 'error'
          });
        })
      },
      openTimetasks(){
        let admin_id=this.$store.state.a_id;
        commonAPI('openTimeTasks',this.formInline).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){}
        }).catch(error=>{
          this.loading = false;
          this.$notify({//这里采用element ui的一个错误显示效果模板
            title: '提示',
            message: error.message,
            position: 'bottom-right',
            type: 'error'
          });
        })
      },
      //进行判定
      chark(){
        this.$emit("parentHandle", 2)
      },
      //重置查询
      resetting() {
        this.formInline.type = '';
        this.formInline.name = '';
        this.getData();
      },
      //添加内容
      AddLabel(){
        //console.log(this.AddForm.start_time);
        //console.log(new Date().getTime());
        this.$refs.AddForm.validate(valid => {
        if (valid) {
          let time=new Date(this.AddForm.start_time).getTime()
          let newdate=new Date().getTime();//获取当前时间
          if(time*1<newdate*1){//判断日期是否在今天以前
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: "不能选择过去的时间",
              position: 'bottom-right',
              type: 'error'
            });
            return false;
          }
          if(this.AddForm.repeat_type=="0"){
            this.AddForm.interval_time="0";
          }else if(this.AddForm.repeat_type=="1"){
            this.AddForm.interval_time=1000*60*60*24;
          }else{
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: "系统错误",
              position: 'bottom-right',
              type: 'error'
            });
            return false;
          }
          this.AddForm.admin_id=this.$store.state.a_id;
          commonAPI('ADDTimeTask',this.AddForm).then(res => {
            let data = res.data;
            //console.log(res.data.rows);
            if(this.response.response(data)){
              this.AddForm.type_name='';
              this.AddForm.type='';
              this.getData();
              this.close();
            }
          }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
        }else{
          return false;
        }
        })
      },
      //修改内容
      UpdateLabel(){
        this.$refs.AddForm.validate(valid => {
        if (valid) {
          let time=new Date(this.AddForm.start_time).getTime()
          let newdate=new Date().getTime();//获取当前时间
          if(time*1<newdate*1){//判断日期是否在今天以前
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: "不能选择过去的时间",
              position: 'bottom-right',
              type: 'error'
            });
            return false;
          }
          if(this.AddForm.repeat_type=="0"){
            this.AddForm.interval_time="0";
          }else if(this.AddForm.repeat_type=="1"){
            this.AddForm.interval_time=1000*60*60*24;
          }else{
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: "系统错误",
              position: 'bottom-right',
              type: 'error'
            });
            return false;
          }
          this.AddForm.admin_id=this.$store.state.a_id;
          this.AddForm.time=newdate;
          commonAPI('updateTimeTask',this.AddForm).then(res => {
            let data = res.data;
            //console.log(res.data.rows);
            if(this.response.response(data)){
              this.AddForm.name='';
              this.AddForm.task_id='';
              this.AddForm.describe='';
              this.AddForm.start_time='';
              this.AddForm.interval_time='';
              this.AddForm.repeat_type='';
              this.getData();
              this.close();
            }
          }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
        }else{
          return false;
        }
        })
      },
      //打开窗口
      Updatewindow(row){
        this.getTaskType();
        this.AddForm=row;
        this.AddForm.tp=1;
        document.getElementById('AddForm_timetask').style.display='block';
        document.getElementById('zhedang').style.display='block';
      },
      Addwindow(row){
        this.getTaskType();
        //this.AddForm.message_id=row.id;
        this.AddForm.tp=0;
        document.getElementById('AddForm_timetask').style.display='block';
        document.getElementById('zhedang').style.display='block';
        //console.log('打开窗口');
      },
      //删除
      deletes(index, row) {
        let admin_id=this.$store.state.a_id;
        row.admin_id=admin_id;
        //console.log(index, row);
        commonAPI('deleteTimeTask',row).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //状态修改
      updateType(index, row) {
        if(row.type=="1"){
          row.type="0"
        }else{
          row.type="1"
        }
        let admin_id=this.$store.state.a_id;
        row.admin_id=admin_id;
        let newdate=new Date().getTime();//获取当前时间
        row.time=newdate;
        //console.log(index, row);
        commonAPI('updateTimeTask',row).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //查询
      getData() {
        this.loading = true,
        commonAPI('queryTimeTaskList',this.formInline).then(res => {
          this.loading = false;
          this.tableData = res.data.data.rows;
          this.pageTotal=res.data.data.total;
          //console.log(res.data.rows);
        })
      },
      //查询任务类型
      getTaskType(){
        commonAPI('queryTaskList',this.formInline).then(res => {
          this.options_task = res.data.data.rows;
          //console.log(res.data.rows);
        })
      },
      onSubmit() {
        this.getData();
      },
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.formInline.pageSize=val;
        this.formInline.pageNum=1;
        this.getData();
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.formInline.pageNum=val;
        this.getData();
      },
      close(){
        this.AddForm.title='';
        this.AddForm.content='';
        this.AddForm.tp=0;
        document.getElementById('AddForm_timetask').style.display='none';
        document.getElementById('zhedang').style.display='none';
      },
    }
  }
</script>

<style scoped>
  .elInput,
  .btn {
    margin-top: 0px;
  }
  .el-main {
    padding: 5px 10px;
  }
  .elMain{
    height: 700px;
  }
  .el-table th {
    height: 45px;
    font-size: 16px;
    font-family: 微软雅黑;
    font-weight: 500;
    color: darkblue;
  }
  /**登录框架*/
  .logindiv{
    position: fixed;
    top: 10%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:25;
    overflow: auto;
    text-align: center;
    display: none;
  }
  .loginForm{
    margin: 0 auto;
    width: 550px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginForm a{
    color: #fff;
  }
  .loginForm a:hover{
    color: #d6d6d6;
  }

  /**Orderinfor框架*/
  .Orderinfordiv{
    position: fixed;
    top: 13%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    display: none;
  }
  .OrderinforForm{
    margin: 0 auto;
    width: 900px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .OrderinforForm a{
    color: #fff;
  }
  .OrderinforForm a:hover{
    color: #d6d6d6;
  }
  .playlistbox_botton{
     width: 900px;margin: 0 auto;
     overflow: hidden;
     height: 633px;
     overflow-y: scroll;
   }
   /**滚动条样式*/
   .playlistbox_botton::-webkit-scrollbar{
     width: 5px;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     border-radius: 10px;
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     background: #535353;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     border-radius: 10px;
     background: #EDEDED;
   }
   /**！Orderinfor框架*/
</style>



// WEBPACK FOOTER //
// src/admin/views/time/TimeTask.vue